import { IconShieldCheck, IconCircleCheck, IconAlertTriangle } from '@tabler/icons-react';
import { SECURITY_TIPS } from './data';
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function SecurityTipsCard() {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon} style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981' }}><IconShieldCheck size={18} /></div>
          <div><div className={styles.cardTitle}>Security Tips</div></div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {SECURITY_TIPS.map((tip, i) => (
            <div className={styles.tipRow} key={i}>
              {tip.tone === 'good'
                ? <IconCircleCheck size={18} style={{ color: '#10b981', flexShrink: 0, marginTop: 1 }} />
                : <IconAlertTriangle size={18} style={{ color: '#d97706', flexShrink: 0, marginTop: 1 }} />}
              <p>{tip.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}